import * as types from '../actionTypes/index';
import {setLoadingStatus} from './commonAction';
import {getProductCompareList} from '../../services/productListService';
export const addRemoveProductToCompare =  (isSelected, product) => dispatch => { 
     if(isSelected) {
        dispatch({ type: types.ADD_COMPARE_PRODUCT, payload: product });
     } else {
        dispatch({ type: types.REMOVE_COMPARE_PRODUCT, payload: product });
     }      
}

export const removeCompareProducts =  () => dispatch => { 
   dispatch({ type: types.REMOVE_ALL });  
}

export const showCompareError =  (errMsg) => dispatch => { 
   dispatch({ type: types.SHOW_COMPARE_ERROR, payload: errMsg });  
}

export const getCompareData = (ids = '') => async dispatch => {
   try {
       setLoadingStatus(true, dispatch);
       const result = await getProductCompareList(ids);
       dispatch({ type: types.PRODUCT_COMPARE_LIST, payload: result });
   } catch (error) {
       setLoadingStatus(false, dispatch);
   } finally {
       setLoadingStatus(false, dispatch);
   }
}

export const replaceCompareProduct = (previousItem, currentItem, isNewItemToCompare) => dispatch => {
   const replaceObj = {
      previousItem: previousItem,
      currentItem: currentItem
   }
   if(isNewItemToCompare) {
      dispatch({ type: types.ADD_COMPARE_PRODUCT, payload: currentItem });
   } else {
      dispatch({ type: types.REPLACE_COMPARE_PRODUCT, payload: replaceObj });
   }
}